<template>
  <div class="card px-24 py-16" :class="[typeClass]">
    <div v-if="leftIconClass" class="card__left-icon">
      <span :class="[leftIconClass]"></span>
    </div>
    <p class="card__body">
      <slot name="body"></slot>
    </p>

    <div
      v-if="isDismissable"
      class="card__right-icon"
      @click="$emit('closeCard')"
    >
      <span class="icon-close"></span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CardWrapper',
  props: {
    leftIconClass: {
      type: String,
      default: ''
    },
    typeClass: {
      type: String,
      default: 'card--general'
    },
    isDismissable: {
      type: Boolean,
      default: false
    }
  },
  emits: ['closeCard']
}
</script>

<style lang="scss">
.card {
  width: 100%;
  height: auto;
  background-color: var(--color-gray-2);
  border-radius: var(--grid-8);
  display: flex;
  align-items: center;

  &__right-icon {
    cursor: pointer;
  }

  &__body {
    font-size: var(--font-size-s);
    margin-left: rem(8);
  }

  &--general {
    background-color: var(--color-general-bg);

    .card__left-icon {
      color: var(--color-general-text);
    }

    .card__body {
      color: var(--color-general-text);
    }
  }

  &--success {
    background-color: var(--color-success-bg);

    .card__left-icon {
      color: var(--color-success-text);
    }

    .card__body {
      color: var(--color-success-text);
    }
  }

  &--warning {
    background-color: var(--color-warning-bg);

    .card__left-icon {
      color: var(--color-warning-text);
    }

    .card__body {
      color: var(--color-warning-text);
    }
  }

  &--error {
    background-color: var(--color-error-bg);

    .card__left-icon {
      color: var(--color-error-text);
    }

    .card__body {
      color: var(--color-error-text);
    }
  }

  &--info {
    background-color: var(--color-info-bg);

    .card__left-icon {
      color: var(--color-info-text);
    }

    .card__body {
      color: var(--color-info-text);
    }
  }
}
</style>
